import React, { useContext } from 'react';
import EDGrid from '../../../../../../BaseComponents/GridComponents/EDGrid';
import { ObjektVyContext } from '../ObjektVy/ObjektVy';
import { makeStyles } from 'tss-react/mui';
import { VisningsTypContext } from '../VisningsTypContext/VisningsTypContext';
import { useIsBreakpointOrSmaller } from '../../../../../../Components/BreakpointContext/BreakpointContextUtils';

const useStyles = makeStyles()(
  theme =>
    ({
      container: {
        // '& > :nth-of-type(odd)': {
        //   paddingRight: 8,
        // },
        // '& > :nth-of-type(even)': {
        //   paddingLeft: 8,
        // },
      },
      item: {},
      fullHeight: {
        height: '100%',
        overflow: 'auto',
      },
      flex: {
        display: 'flex',
        flexDirection: 'column',
      },
    } as const)
);

const ObjektVyKolumner: React.FunctionComponent<
  React.PropsWithChildren<{
    fullHeight?: boolean;
  }>
> = props => {
  const { classes, cx } = useStyles();
  const [objektVyContext] = useContext(ObjektVyContext);
  const visningsTypContext = useContext(VisningsTypContext);
  const smallBreakpoint = useIsBreakpointOrSmaller('sm');
  return (
    <EDGrid
      container
      spacing={2}
      className={cx({
        [classes.container]:
          React.Children.count(props.children) > 1 &&
          !objektVyContext.sidaVidSida &&
          !smallBreakpoint &&
          !visningsTypContext.showDetailsRight,
        [classes.fullHeight]: props.fullHeight,
      })}
    >
      {props.children}
    </EDGrid>
  );
};

export const ObjektVyKolumn: React.FunctionComponent<
  React.PropsWithChildren<{
    fullPage?: boolean;
    fullHeight?: boolean;
    flex?: boolean;
  }>
> = props => {
  const [objektVyContext] = useContext(ObjektVyContext);
  const { classes, cx } = useStyles();
  return (
    <EDGrid
      item
      xs={12}
      md={objektVyContext.sidaVidSida ? 12 : props.fullPage ? 6 : 12}
      className={cx(classes.item, {
        [classes.fullHeight]: props.fullHeight,
        [classes.flex]: props.flex,
      })}
    >
      {props.children}
    </EDGrid>
  );
};
export default ObjektVyKolumner;
